import { GRAPH_NODE_TYPE_REGISTRY, type NodeLabel } from '@atbash-labs/ontology-core'
import { PLANT_SURFACE_BY_LABEL, TAGS_ROOT } from '@atbash-labs/plantview-links'

export type EntitySurfaceDecision =
  | { kind: 'redirect'; href: string; label: NodeLabel }
  | { kind: 'generic'; label: NodeLabel | null }

export function registeredLabel(labels: string[]): NodeLabel | null {
  return (
    labels.find((label): label is NodeLabel =>
      Object.prototype.hasOwnProperty.call(GRAPH_NODE_TYPE_REGISTRY, label)
    ) ?? null
  )
}

function isTagsPageHref(href: string): boolean {
  return href === TAGS_ROOT || href.startsWith(`${TAGS_ROOT}?`)
}

/** Callers who can't open the Tags page get the generic page for nodes that would redirect there. */
export function resolveEntitySurface(
  result: {
    labels: string[]
    entity: { id: string; [key: string]: unknown }
  },
  { canOpenTagsPage }: { canOpenTagsPage: boolean }
): EntitySurfaceDecision {
  const label = registeredLabel(result.labels)
  if (label) {
    const surface = PLANT_SURFACE_BY_LABEL[label]
    if (surface.kind === 'bespoke') {
      const href = surface.href(result.entity.id, result.entity)
      if (href && (canOpenTagsPage || !isTagsPageHref(href))) {
        return { kind: 'redirect', href, label }
      }
    }
  }
  return { kind: 'generic', label }
}
